import './App.css';
import Header from './GIS-en/header/header'
import Model1 from './GIS-en/model1/Model1';
import Footer from './GIS-en/Footer/Footer';
import Cover from './GIS-en/cover/cover';
import Stack from './GIS-en/stack/stack';


function GeApp() {
  return (
    <div className="App">
      <Header />
      <Cover />
      <section id="stack">
      <Stack />
      </section>
      <section id="team">
      <Model1 />
      </section>
      <section id="contacts">
      <Footer />
      </section>
    </div>
  );
}

export default GeApp;
